{
  "typeToConfirm": "To confirm, type"
}
